import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '../../../hooks/useRouter';
import useQuery from './useQuery';
import Evaluation from './Evaluation';
import useSchoolYearParams from '../../evaluations/useSchoolYearParams';
import { parse } from 'query-string';

export default function Layout(props) {
  const { location } = useRouter();

  const params = useSchoolYearParams();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    search: parse(location.search),
    PAGE_SIZE,
    network: params.network,
    schoolStart: params.schoolStart,
    schoolEnd: params.schoolEnd
  });

  return (
    <ParentLayout
      location={location}
      extra={{
        schoolStart: params.schoolStart,
        schoolEnd: params.schoolEnd,
        variant: 'testimonials'
      }}
      breadcrumbs={['Evaluations', 'Events: Educators']}
      title="Testimonials"
      description={(
        <>
          Testimonials provided by an educator as part of their event evaluation.
        </>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      row={function(evaluationEventEducator) {
        return (
          <Evaluation
            key={evaluationEventEducator.id}
            evaluation={evaluationEventEducator}
          />
        );
      }}
    />
  );
}
